require("select2/dist/js/select2.full.js")
require("select2/dist/js/i18n/de.js")
require("select2/dist/css/select2.css")

import { Component, AfterViewInit, ElementRef, Self, Input }  from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import {ViewEncapsulation} from '@angular/core';

declare var jQuery: any;

@Component({
	selector: 'combobox-ajax',
	templateUrl: "./combobox.html",
	styles: [require("./combobox.scss")],
	encapsulation: ViewEncapsulation.None

})
export class ComboboxAjax implements ControlValueAccessor, AfterViewInit {
	private select2: any;
	private el;
	private controlValueAccessorChanged = (_) => {};
	private controlValueAccessorTouched = () => {};

	@Input() searchMethod: any;
	@Input() getObjectMethod: any;
	@Input() convertObjectMethod: any;
	@Input() displayHtml: boolean;

	constructor(private ngFormControl: NgControl, private elementRef: ElementRef) {
		ngFormControl.valueAccessor = this;
	}

	ngAfterViewInit() {

		let select2Config = {
			language: 'de',
			minimumInputLength: 3,
			ajax: {
				transport: (params, success, failure) => {
					this.searchMethod(params.data.term).subscribe((data) => {
						success(data)
					}, (error) => {
						failure(error)
					})
				},
				delay: 250,
				processResults: (data) => {
					return {
						results: this.processSearchResult(data)
					}
				}
			}
		}

		if (this.displayHtml) {
			select2Config['templateResult'] = data => data.html;
			select2Config['templateSelection'] = data => data.text;
			select2Config['escapeMarkup'] = markup => markup;
		}

		this.el = jQuery(this.elementRef.nativeElement).find("select");
		this.select2 = this.el.select2(select2Config);

		this.select2.on("select2:close", (e) => {
			this.updateControlValueAccessor(this.el.val())
			this.updateCss()
		})
}

	writeValue(obj: any): void {
		if (obj && this.getObjectMethod) {
			this.loadSelectedObject(obj)
		}
	}

	registerOnChange(fn: any): void {
		this.controlValueAccessorChanged = fn;
	}

	registerOnTouched(fn: any): void {
		this.controlValueAccessorTouched = fn;
	}

	private updateControlValueAccessor(optionId: string) {
		this.controlValueAccessorTouched();
		if (!optionId) {
			this.controlValueAccessorChanged(null);
			return;
		}
		this.controlValueAccessorChanged(parseInt(optionId));
	}

	private updateCss() {
		if (this.ngFormControl.dirty && !this.ngFormControl.valid) {
			jQuery(this.elementRef.nativeElement).find(".select2-selection").attr("class", "select2-selection select2-selection--single invalid")
		} else {
			jQuery(this.elementRef.nativeElement).find(".select2-selection").attr("class", "select2-selection select2-selection--single")
		}
	}

	private processSearchResult(data) {
		let options: {id: number, text: string, html: string}[] = [];
		data.forEach((object) => {
			let convertedObject: {id: number, displayText: string, html: string} = this.convertObjectMethod(object)
			options.push({id: convertedObject.id, text: convertedObject.displayText, html: convertedObject.html})
		})
		return options;
	}

	private loadSelectedObject(id: string) {
		this.getObjectMethod(id).subscribe((data) => {
			let convertedObject: {id: number, displayText: string} = this.convertObjectMethod(data)
			let option = jQuery('<option selected></option>')
			option.text(convertedObject.displayText)
			option.val(convertedObject.id)
			this.el.append(option)
			this.select2.trigger("change")
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/combobox/combobox-ajax.component.ts